import React from 'react';
import styled from 'styled-components';
import { formatShortDate } from 'shared/screens/Events/utils/getPendingTargetShortDate';
import { TEXT_KEY, getText } from 'shared/utils/localization';
import { isMobile } from 'react-device-detect';

function PendingWrapper({ openCardDetail, startTimestamp = 0 }) {
  const targetDateString = formatShortDate(startTimestamp);
  const TargetDateText = `${getText(TEXT_KEY.EVENTS_COMING_SOON_LABEL)} ${targetDateString}`.toLocaleUpperCase();
  return (
    <PendingWrapperContainer $openCardDetail={openCardDetail}>
      <TextStack $openCardDetail={openCardDetail} data-text={TargetDateText}>
        <span>{TargetDateText}</span>
      </TextStack>
    </PendingWrapperContainer>
  );
}

export default PendingWrapper;

const PendingWrapperContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 95%;
  width: ${({ $openCardDetail }) => ($openCardDetail ? '72vh' : '0')};
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom-right-radius: 2rem;
  background-color: ${({ $openCardDetail }) => ($openCardDetail ? 'rgba(0, 0, 0, 0.7)' : 'transparent')};
  transition: 0.7s ease all;
  padding-left: 2vw;
`;

const TextStack = styled.span`
  position: relative;
  display: inline-block;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  font-size: ${isMobile ? 2.3 : 3}vw;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  opacity: ${({ $openCardDetail }) => ($openCardDetail ? 1 : 0)};
  transition: ${({ $openCardDetail }) => ($openCardDetail ? `2s ease all` : 'none')};

  span {
    position: relative;
    color: #f3cc19;
  }

  &::before {
    content: attr(data-text);
    position: absolute;
    inset: 0;
    z-index: -1;
    color: #764309;
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke: 5px #764309;
  }

  &::after {
    content: attr(data-text);
    position: absolute;
    inset: 0;
    z-index: -1;
    color: #171717;
    opacity: 0.7;
    text-shadow:
      0 0 70px #171717,
      0 0 80px #171717;
  }
`;
